let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5a8LM")).then(() => parcelRequire('h6Xfo'));